import React from "react"
import { MyPageHelpers } from "@macashipo/mlib"

const PManageQuotes = React.lazy(() => import("./Types/ManageQuote"))
const PTableListCard = React.lazy(() => import("./Types/TableListCard"))
const PMangeJobOrder = React.lazy(() => import("./Types/MangeJobOrder"))
const PManageIssuePart = React.lazy(() => import("./Types/ManageOutputStock"))
const PManageOrderStock = React.lazy(
  () => import("./Types/ManageCreateOrderStock")
)
const PManageSaleOrder = React.lazy(() => import("./Types/ManageSaleOrder"))
const PManageOrderStockDetail = React.lazy(
  () => import("./Types/ManageOrderStockDetail")
)
const PManageInputStock = React.lazy(() => import("./Types/ManageInputStock"))
const PMangeJobOrderReadonly = React.lazy(
  () => import("./Types/MangeJobOrderReadonly")
)
const List = {
  manage_quotes: PManageQuotes,
  manage_job_order: PMangeJobOrder,
  manage_outputstock: PManageIssuePart,
  manage_create_orderstock: PManageOrderStock,
  r_table_list_card: PTableListCard,
  manage_sale_order: PManageSaleOrder,
  manage_orderstock_detail: PManageOrderStockDetail,
  manage_inputstock: PManageInputStock,
  manage_job_order_readonly: PMangeJobOrderReadonly,
}
const MyPageOne = {
  init() {
    MyPageHelpers.addTypesFromListLazy(List)
  },
}

export default MyPageOne
